import { RequestHelper } from 'utils';
import { API_ROUTES } from 'utils/constants';

// GET
const getFluidOptions = () => RequestHelper.GET(API_ROUTES.FLUIDS.OPTIONS());

export const FluidService = {
  getFluidOptions
};
